import { safeLazyLoad } from '@/utils/lazyLoad'

export const initialRoutes = [
    {
        path: '/min-side',
        name: 'home',
        meta: { requiresAuth: true }, // Requires auth BUT router guard allows redirect callbacks
        component: () => safeLazyLoad(() => import('../pages/HomePage.vue'))
    },
    {
        path: '/min-side/mine-arrangementer',
        name: 'my-events',
        meta: { requiresAuth: true },
        component: () => safeLazyLoad(() => import('../pages/events/MyEventsPage.vue'))

    },
    {
        path: '/min-side/mine-arrangementer/opret-arrangement',
        name: 'create-event',
        meta: { requiresAuth: true },
        component: () => safeLazyLoad(() => import('../pages/events/create-event/CreateEventPage.vue')),
        children: [
            {
                path: '',
                name: 'createEventStep1',
                component: () => safeLazyLoad(() => import('../pages/events/create-event/CreateEventPageStep1.vue'))
            },
            {
                path: 'detaljer',
                name: 'createEventStep2',
                component: () => safeLazyLoad(() => import('../pages/events/create-event/CreateEventPageStep2.vue'))
            },
            {
                path: 'godkend',
                name: 'createEventStep3',
                component: () => safeLazyLoad(() => import('../pages/events/create-event/CreateEventPageStep3.vue'))
            }
        ]
    },
    {
        path: '/min-side/kvittering',
        name: 'event-created',
        meta: { useTransparentLayout: false, requiresAuth: false },
        component: () => safeLazyLoad(() => import('../pages/events/EventCreateSuccesPage.vue'))
    },
    {
        path: '/admin',
        name: 'admin',
        meta: { requiresAuth: true, isAdmin: true },
        component: () => safeLazyLoad(() => import('../pages/admin/AdminPage.vue'))
    },
    {
        path: '/admin/users',
        name: 'admin-users',
        meta: { requiresAuth: true, isAdmin: true },
        component: () => safeLazyLoad(() => import('../pages/admin/AdminUsersPage.vue'))
    },
    {
        path: '/admin/session-status',
        name: 'session-status',
        meta: { requiresAuth: true, isAdmin: true },
        component: () => safeLazyLoad(() => import('../pages/admin/SessionStatusPage.vue'))
    },
    {
        path: '/admin/events',
        name: 'admin-events',
        meta: { requiresAuth: true, isAdmin: true },
        component: () => safeLazyLoad(() => import('../pages/admin/AdminEventsPage.vue'))
    },
    {
        path: '/admin/db-inspection',
        name: 'db-inspection',
        meta: { requiresAuth: true, isAdmin: true },
        component: () => safeLazyLoad(() => import('../pages/admin/DbInspectionPage.vue'))
    },
    {
        path: '/admin/adgang-naegtet',
        name: 'ip-not-allowed',
        meta: { requiresAuth: false, isAdmin: false },
        component: () => safeLazyLoad(() => import('../pages/admin/IpNotAllowedPage.vue'))
    },
    {
        path: '/admin/forbudt',
        name: 'admin-access-denied',
        meta: { requiresAuth: false, isAdmin: false },
        component: () => safeLazyLoad(() => import('../pages/admin/AdminAccessDeniedPage.vue'))
    },

    // Profile pages
    {
        path: '/min-side/profil',
        name: 'profile',
        meta: { requiresAuth: true },
        component: () => safeLazyLoad(() => import('../pages/profile/ProfilePage.vue'))
    },
    {
        path: '/min-side/profil/rediger-profil',
        name: 'edit-profile',
        meta: { requiresAuth: true },
        component: () => safeLazyLoad(() => import('../pages/profile/EditProfilePage.vue'))
    },
    {
        path: '/min-side/profil/administrer-arrangoerer',
        name: 'edit-organizers',
        meta: { requiresAuth: true },
        component: () => safeLazyLoad(() => import('../pages/profile/EditOrganizersPage.vue'))
    },
    {
        path: '/signin',
        name: 'signin',
        meta: { requiresAuth: true },
        component: () => safeLazyLoad(() => import('../pages/profile/EditProfilePage.vue'))
    },
    {
        path: '/',
        name: 'events-search',
        meta: { requiresAuth: false },
        component: () => safeLazyLoad(() => import('../pages/event/EventSearchPage.vue'))
    },
    {
        path: '/ophavsret',
        name: 'copyright',
        meta: { requiresAuth: false},
        component: () => safeLazyLoad(() => import('../pages/Copyright.vue'))
    },
    {
        path: '/changelog',
        name: 'changelog',
        meta: { requiresAuth: false},
        component: () => safeLazyLoad(() => import('../pages/ChangeLog.vue'))
    },
    {
        path: '/admin/system-status',
        name: 'system-status',
        meta: { requiresAuth: true, isAdmin: true },
        component: () => safeLazyLoad(() => import('../pages/SystemStatusPage.vue'))
    },

    // Event pages (flat routes — avoid nested EventsPage shell + duplicate "/" alias)
    {
        path: '/arrangementer',
        name: 'events-overview',
        meta: { requiresAuth: false },
        component: () => safeLazyLoad(() => import('../pages/event/EventSearchPage.vue'))
    },
    {
        path: '/arrangementer/:id',
        name: 'event-page',
        props: true,
        meta: { requiresAuth: false },
        component: () => safeLazyLoad(() => import('../pages/event/EventPage.vue'))
    },

    // Create user pages
    {
        path: '/min-side/opret-bruger',
        name: 'createUser',
        component: () => safeLazyLoad(() => import('../pages/create-user/CreateUser.vue')),
        meta: {
            layout: 'EmptyLayout'
        },
        children: [
            {
                path: '',
                name: 'yourProfile',
                component: () => safeLazyLoad(() => import('../pages/create-user/YourProfilePage.vue'))
            }
        ]
    },

    // Not found 404 page
    {
        path: '/:pathMatch(.*)*',
        name: 'notFound',
        component: () => safeLazyLoad(() => import('../pages/NotFoundPage.vue'))
    }
]